export function filter(node, filter) {
  // map and filter
}